import { Skeleton, SkeletonProps } from "@mui/material";

type CoreSkeletonWrapperProps = {
	/**If `loading`, returns skeleton. Otherwise returns `children` */
	loading?: boolean;
	children: React.ReactNode;
	/**@default 100% */
	width?: string | number;
	/**@default 100px */
	height?: number | string;
} & Omit<SkeletonProps, "height" | "width" | "children">;

export default function CoreSkeletonWrapper({
	children,
	loading,
	width = "100%",
	height = "100px",
	variant = "rounded",
	...props
}: CoreSkeletonWrapperProps) {
	if (!loading) return children;

	return <Skeleton {...props} variant={variant} width={width} height={height} />;
}
